export const EMPTY_ASSETS_LIBRARY_LIST = {
  null: {
    folders: [
    ],
    items: [
    ],
  },
};

const videoMetadata = {
  avgFrameRate: '25/1',
  bitRate: 182960,
  codecName: 'h264',
  codecTagString: 'avc1',
  codecType: 'video',
  displayAspectRatio: 'N/A',
  duration: 29.52,
  durationTimeBase: 377856,
  frames: 738,
  height: 720,
  timeBase: '1/12800',
  width: 1280,
};

export const ASSETS_LIBRARY_LIST = {
  null: {
    folders: [
      {
        id: 'qiWBKLsOnjI',
        name: '2021',
        coverImageS3Url: null,
        parentId: null,
        companyId: '3GB0gmaOeZk',
        createdAt: '2022-07-28T17:49:23.000Z',
        updatedAt: '2022-07-28T17:51:01.000Z',
        isDirectory: true,
      },
      {
        id: 'aysdFcsJ4aT',
        name: 'HasAssets',
        coverImageS3Url: null,
        parentId: null,
        companyId: '3GB0gmaOeZk',
        createdAt: '2022-07-28T17:49:23.000Z',
        updatedAt: '2022-07-28T17:51:01.000Z',
        isDirectory: true,
      },
    ],
    items: [
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'P8FlIn9XM7e',
        isDirectory: false,
        isFile: true,
        mimeType: 'audio/mpeg',
        name: 'sky',
        size: '2486840',
        sizeBase64: '3315811',
        src: 'assets/EogouBvjb8y-1658854652864-P8FlIn9XM7e.mp3',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'ngeYWM24Euc',
        isDirectory: false,
        isFile: true,
        mimeType: 'image/png',
        name: 'leprechaun',
        size: '5416',
        sizeBase64: '3315811',
        src: 'assets/icons8-jake-150.png',
        updatedAt: 1658944364,
        bucket: 'assetsbucket-1glz1lo7t2eve',
        metadata: {
          height: 400,
          width: 400,
        },
        type: 'image',
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hA2EvohNNJo',
        isDirectory: false,
        isFile: true,
        mimeType: 'font/otf',
        name: 'GreatVibes-Regular',
        size: '52928',
        sizeBase64: '70593',
        src: 'assets/EogouBvjb8y-1659025996825-hA2EvohNNJo.otf',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'r21UXqBZn80',
        isDirectory: false,
        isFile: true,
        mimeType: 'image/png',
        name: 'back_ui_left0001.png',
        size: '12079',
        sizeBase64: '16130',
        src: 'assets/icons8-jake-150.png',
        updatedAt: 1658944364,
        metadata: {
          height: 100,
          width: 400,
        },
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'Ozv41ZilHs2',
        isDirectory: false,
        isFile: true,
        mimeType: 'video/mp4',
        name: 'sample_640x360_1.mp4',
        size: '2372820',
        sizeBase64: '3163782',
        src: 'assets/sample_640x360.mp4',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'eEEoSEH8giq',
        isDirectory: false,
        isFile: true,
        mimeType: 'font/ttf',
        name: 'Chalkboard-01.ttf',
        size: '74952',
        sizeBase64: '99957',
        src: 'assets/EogouBvjb8y-1658957648517-eEEoSEH8giq.ttf',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'j3rZuAKGSVe',
        isDirectory: false,
        isFile: true,
        mimeType: 'audio/mpeg',
        name: 'file_example_MP3_700KB (1)',
        size: '764176',
        sizeBase64: '1018927',
        src: 'assets/EogouBvjb8y-1659020241911-j3rZuAKGSVe.mpga',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hBf-sPlI0Sx',
        isDirectory: false,
        isFile: true,
        mimeType: 'video/mp4',
        name: 'sample_640x360_2.mp4',
        size: '2299653',
        sizeBase64: '3066226',
        src: 'assets/sample_640x360.mp4',
        updatedAt: 1658944364,
        metadata: videoMetadata,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hBf-sPlI0Sx123',
        isDirectory: false,
        isFile: true,
        mimeType: 'video/mp4',
        name: 'sample_640x360_3.mp4',
        size: '2299653',
        sizeBase64: '3066226',
        src: 'assets/sample_640x360.mp4',
        updatedAt: 1658944364,
        metadata: {
          ...videoMetadata,
          duration: 70.52,
        },
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hBf-sPlI0Sx000',
        isDirectory: false,
        isFile: true,
        mimeType: 'video/mp4',
        name: 'sample_640x360_3.mp4',
        size: '2299653',
        sizeBase64: '3066226',
        src: 'assets/sample_640x360.mp4',
        updatedAt: 1658944364,
        metadata: {
          ...videoMetadata,
          duration: 0.02,
        },
      },
    ],
  },
  qiWBKLsOnjI: {
    folders: [
      {
        id: 'ZmBqE4vbCho',
        name: 'Q1',
        parentId: 'qiWBKLsOnjI',
        companyId: '3GB0gmaOeZk',
        coverImageS3Url: null,
        createdAt: '2022-07-28T17:49:23.000Z',
        updatedAt: '2022-07-28T17:51:01.000Z',
      },
    ],
    items: [
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'P8FlIn9XM7e',
        isDirectory: false,
        isFile: true,
        mimeType: 'audio/mpeg',
        name: 'sky',
        size: '2486840',
        sizeBase64: '3315811',
        src: 'assets/EogouBvjb8y-1658854652864-P8FlIn9XM7e.mp3',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'ngeYWM24Euc',
        isDirectory: false,
        isFile: true,
        mimeType: 'image/png',
        name: 'leprechaun',
        size: '5416',
        sizeBase64: '3315811',
        src: 'assets/icons8-jake-150.png',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hA2EvohNNJo',
        isDirectory: false,
        isFile: true,
        mimeType: 'font/otf',
        name: 'GreatVibes-Regular',
        size: '52928',
        sizeBase64: '70593',
        src: 'assets/EogouBvjb8y-1659025996825-hA2EvohNNJo.otf',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'Ozv41ZilHs2',
        isDirectory: false,
        isFile: true,
        mimeType: 'video/mp4',
        name: 'sample_640x360.mp4',
        size: '2372820',
        sizeBase64: '3163782',
        src: 'assets/sample_640x360.mp4',
        updatedAt: 1658944364,
      },
    ],
  },
  ZmBqE4vbCho: {
    folders: [
      {
        id: 'ZmBqE586Cho',
        name: 'EA',
        parentId: 'ZmBqE4vbCho',
        companyId: '3GB0gmaOeZk',
        coverImageS3Url: null,
        createdAt: '2022-07-28T17:49:23.000Z',
        updatedAt: '2022-07-28T17:51:01.000Z',
      },
    ],
    items: [],
  },
  ZmBqE586Cho: {
    folders: [
      {
        id: 'AABqE586Cho',
        name: 'Image Folder',
        parentId: 'ZmBqE586Cho',
        companyId: '3GB0gmaOeZk',
        coverImageS3Url: null,
        createdAt: '2022-07-28T17:49:23.000Z',
        updatedAt: '2022-07-28T17:51:01.000Z',
      },
    ],
    items: [
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'P8FlIn9XM7e',
        isDirectory: false,
        isFile: true,
        mimeType: 'audio/mpeg',
        name: 'sky',
        size: '2486840',
        sizeBase64: '3315811',
        src: 'assets/EogouBvjb8y-1658854652864-P8FlIn9XM7e.mp3',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'ngeYWM24Euc',
        isDirectory: false,
        isFile: true,
        mimeType: 'image/png',
        name: 'leprechaun',
        size: '5416',
        sizeBase64: '3315811',
        src: 'assets/icons8-jake-150.png',
        updatedAt: 1658944364,
      },
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'hA2EvohNNJo',
        isDirectory: false,
        isFile: true,
        mimeType: 'font/otf',
        name: 'GreatVibes-Regular',
        size: '52928',
        sizeBase64: '70593',
        src: 'assets/EogouBvjb8y-1659025996825-hA2EvohNNJo.otf',
        updatedAt: 1658944364,
      },
    ],
  },
  AABqE586Cho: {
    folders: [],
    items: [],
  },
  aysdFcsJ4aT: {
    folders: [],
    items: [
      {
        createdAt: 1658937477,
        folderId: null,
        id: 'ngeYWM24Euc',
        isDirectory: false,
        isFile: true,
        mimeType: 'image/png',
        name: 'leprechaun',
        size: '5416',
        sizeBase64: '3315811',
        src: 'assets/icons8-jake-150.png',
        updatedAt: 1658944364,
      },
    ],
  },
};

export default ASSETS_LIBRARY_LIST;
